import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import bs58 from 'bs58';

@Injectable({
  providedIn: 'root',
})
export class IpfsService {
  url: string;
  token: string;

  constructor() {
    this.url = environment.ipfsConfig.url;
    this.token = environment.ipfsConfig.token;
  }

  /**
   * Fetch metadata from IPFS by bytes32 ID
   * @returns Parsed JSON object or null on error

   */
  public async getMeta(id: string): Promise<any | null> {
    try {
      const uri = this.getIpfsHashFromBytes32(id);
      const url = `${this.url}/api/v0/cat?arg=${uri}`;

      const headers = new Headers();
      headers.set('Authorization', `Bearer ${this.token}`);

      const res = await fetch(url, {
        method: 'POST',
        headers: headers,
      });

      if (!res.ok) {
        console.error(`IPFS fetch failed for ${id}: ${res.status} ${res.statusText}`);
        return null;
      }

      const data = await res.json();
      return data;
    } catch (err) {
      console.error(`IPFS getMeta error for ${id}:`, err);
      return null;
    }
  }

  /**
   * Upload metadata to IPFS
   * @returns bytes32 hash or undefined on error

   */
  public async setMeta(data: object): Promise<string | undefined> {
    try {
      const url = `${this.url}/api/v0/add`;

      const headers = new Headers();
      headers.set('Authorization', `Bearer ${this.token}`);

      const files = new FormData();
      files.append('file', JSON.stringify(data));

      const res = await fetch(url, {
        method: 'POST',
        headers: headers,
        body: files,
      });

      if (!res.ok) {
        console.error(`IPFS upload failed: ${res.status} ${res.statusText}`);
        return undefined;
      }

      const result = await res.json();
      return this.getBytes32FromIpfsHash(result.Hash);
    } catch (err) {
      console.error('IPFS setMeta error:', err);
      return undefined;
    }
  }

  private getBytes32FromIpfsHash(uri: string): string {
    return '0x' + Buffer.from(bs58.decode(uri).slice(2)).toString('hex');
  }

  private getIpfsHashFromBytes32(bytes32Hex: string): string {
    const hashHex = '1220' + bytes32Hex.slice(2);
    const hashBytes = Buffer.from(hashHex, 'hex');
    const hashStr = bs58.encode(hashBytes);
    return hashStr;
  }
}
